import { consentContext } from '../../consentAudit/types';

/**
 * The consent documents that carry a published version. The other contexts on the audit trail are
 * either campaign-owned terms or standing questions with no document behind them, so core rejects
 * them and they are not offered here.
 */
export const versionedConsentContext = {
  grassrootzTerms: consentContext.grassrootzTerms,
  privacyPolicy: consentContext.privacyPolicy
} as const;
export type VersionedConsentContext =
  (typeof versionedConsentContext)[keyof typeof versionedConsentContext];

export interface PublishConsentDocumentVersion {
  context: VersionedConsentContext;
  effectiveAt: string;
  requiresReAcceptance: boolean;
  version: string;
}
